export default __webpack_public_path__ + "static/neckband-97131c1afd8bb058eb19867896a3f85a.png";